import {
  Ballot,
  Description,
  ExitToApp,
  Help,
  Home,
  VpnKeyOutlined,
} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {getLocale} from '../../../i18n/helper';
import {getPath} from '../../../routes';
import {Menu} from '../../../shared/components';
import Logo from '../../../shared/components/Logo';
import {getUser} from '../../auth/store/selectors';
import ChangeLenguage from '../components/ChangeLenguage';
import {getElection} from '../store/selectors';
import './screen.css';

interface IMenu {
  icon: any;
  name: string;
  route: string;
  onClick?: (e: any) => void;
}

interface IProps {
  isPageAuth?: boolean;
  hideToolbar?: boolean;
  className?: string;
}

const Screen: React.FC<IProps> = ({
  children,
  isPageAuth,
  hideToolbar,
  className,
}: any) => {
  const {t} = useTranslation();
  const user = useSelector(getUser);
  const election = useSelector(getElection);
  // const info = useSelector(getElectionInfo);
  // const isLoading = info && info.loading;

  const menuItems: IMenu[] = [
    {
      icon: <Home />,
      name: t('tela.eleicoes'),
      route: getPath('home'),
    },
    {
      icon: <Help />,
      name: t('tela.ajuda'),
      route: getPath('help'),
    },
  ];

  // if (isLoading) {
  //  // return <></>;
  // }

  if (!election) {
    return (
      <div className={`screen${isPageAuth ? ' login' : ''} page-${className}`}>
        {hideToolbar ? null : (
          <header>
            {isPageAuth ? null : (
              <Menu menuItems={menuItems} loggedUser={user} />
            )}

            <div className={`header-title ${isPageAuth ? '' : 'mr-60'}`}>
              <Logo height={30} />
              <h1>{t('tela.eleicoes')}</h1>
            </div>
          </header>
        )}

        <div className="screen-content">
          <h2>{t('tela.eleicao-nao-encontrada')}</h2>
        </div>
      </div>
    );
  }

  if (election && !election.configs.i18n_enable && getLocale() !== 'pt') {
    window.localStorage.removeItem('SEI_POCKET_LOCALE');
    location.reload();
  }

  if (election && election._opt_in) {
    menuItems.splice(2, 0, {
      icon: <Description />,
      name: t('tela.acordo'),
      onClick: (e: any) => {
        e.preventDefault();
        if (election && election._opt_in && election._opt_in.file_src) {
          window.open(election._opt_in.file_src, '_blank');
        }
      },
      route: getPath('home'),
    });
  }

  if (election && election.configs.send_receipt_enable) {
    menuItems.splice(3, 0, {
      icon: <Ballot />,
      name: t('consultar-comprovante.titulo'),
      route: getPath('consultarComprovante'),
    });
  }
  if (user) {
    menuItems.splice(4, 0, {
      icon: <VpnKeyOutlined />,
      name: t('tela.trocarSenha'),
      route: getPath('changePassword'),
    });
    menuItems.push({
      icon: <ExitToApp />,
      name: t('tela.sair'),
      route: getPath('logout'),
    });
  } else {
    menuItems.push({
      icon: <ExitToApp />,
      name: t('tela.entrar'),
      route: getPath('auth'),
    });
  }

  return (
    <div className={`screen${isPageAuth ? ' login' : ''} page-${className}`}>
      {hideToolbar ? null : (
        <header>
          <div className={`header-title ${isPageAuth ? '' : 'mr-60 mr-m-0'}`}>
            <div className="content-menu">
              <Logo height={30} />
              {isPageAuth ? null : (
                <Menu menuItems={menuItems} loggedUser={user} />
              )}
            </div>
            <div className="election-identify">
              <h1>{election.name}</h1>
              <span>{election.description}</span>
            </div>

            <div style={{display: 'block', width: '30px'}}>
              {election.configs.i18n_enable && (
                <ChangeLenguage locales={election.configs.i18n_locales} />
              )}
            </div>
          </div>
        </header>
      )}

      <div className={`screen-content${className ? ` ${className}` : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default Screen;



// WEBPACK FOOTER //
// ./src/features/election/screen/Screen.tsx